import { render, staticRenderFns } from "./paytable.vue?vue&type=template&id=66a64c6a&"
import script from "./paytable.vue?vue&type=script&lang=js&"
export * from "./paytable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports